'use client';

import Link from 'next/link';

import { testUrl } from 'src/services/route-utils';
import MyTestButton from 'src/components/MyTestButton';
import useMyTestsState from 'src/hooks/useMyTestsState';
import InfoTooltip from 'src/components/InfoTooltip';

type Props = {
    items: any[];
    title?: string;
    highlightActive?: boolean;
    stickyTitleBar?: boolean;
};

export default function TestsList({
    items,
    title = 'Toate categoriile',
    highlightActive = true,
    stickyTitleBar = true,
}: Props) {
    const { tests } = useMyTestsState();

    return (
        <div className="bg-white">
            {!!items.length && (
                <div
                    className={`bg-lightest-grey flex flex-row items-center gap-4 p-4 text-sm font-bold uppercase${
                        stickyTitleBar ? ' top-nav-sm-height md:top-nav-md-height sticky' : ''
                    }`}>
                    <div className="flex-1">{title}</div>
                    <div>Preț</div>
                    <div className="w-6" />
                </div>
            )}
            <ul className="flex flex-col divide-y text-base">
                {items.map((item) => (
                    <li
                        key={item.slug}
                        className={`text-medium border-lightest-grey flex flex-row items-center gap-4 border-b p-4 md:px-8 ${
                            highlightActive && tests.some((test) => test.slug === item.slug) ? 'bg-light-green' : ''
                        }`}>
                        <div className="flex-1">
                            <Link href={testUrl(item)}>{item.name}</Link>
                            <InfoTooltip title={item.disclaimer} />
                        </div>
                        <div>{item.price}</div>
                        <div className="w-6">
                            <MyTestButton test={item.slug} className="text-2xl" />
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
